import { InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<typeof globalThis>('Global this', {
  factory: () => globalThis,
});
